import Component from './serial_code_used_import.vue'
export default Component
